export default class FilterHelper
{
	/**
	 * @param itemList       Массив объектов номенклатуры
	 * @param filterList     Массив значений фильтров
	 * @param name           Название свойства фильтрации
	 * @param selectedFilter Текущий фильтр
	 * @param itemListFn     Функция получения массива объектов номенклатуры с применением фильтра
	 * @param _this
	 *
	 * @returns array
	 */
	static getFilter(itemList, filterList, name, selectedFilter, itemListFn, _this) {
		if (itemList.length === 0) {
			return [];
		}

		// Если выбран данный фильтр, временно убираем его, для получения всех вариантов по этому свойству
		if (selectedFilter && selectedFilter[name])
		{
			const tmp = selectedFilter[name];

			delete selectedFilter[name];

			const lst = itemListFn.call(_this);

			selectedFilter[name] = tmp;

			return this.getFilter(lst, filterList, name);
		}

		return filterList.filter(filterItem => {
			for (let i = 0; i < itemList.length; i++) {
				if (itemList[i][name] === filterItem) {
					return true;
				}
			}
			return false;
		});
	}
}



// WEBPACK FOOTER //
// ./src/react/FilterHelper.jsx